import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { batchUpdateGetStaff } from "@/api/correspondence/task/form";
export default {
  name: "setGetStaff",
  props: {
    ids: {
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        c02GetStaff: undefined,
        c02GetDate: new Date()
      },
      rules: {
        c02GetStaff: [{
          required: true,
          message: "\u8BF7\u8F93\u5165\u9886\u53D6\u4EBA",
          trigger: 'change'
        }],
        c02GetDate: [{
          required: true,
          message: "\u8BF7\u9009\u62E9\u9886\u53D6\u65E5\u671F",
          trigger: 'change'
        }]
      },
      loading: false
    };
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$checkForm();
            case 1:
              _this.loading = true;
              _context.n = 2;
              return _this.$awaitTo(batchUpdateGetStaff({
                confirmation: {
                  "c02GetStaff": _this.form.c02GetStaff,
                  "c02GetDate": _this.form.c02GetDate
                },
                confirmIds: _this.ids
              }));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this.$message.success(data);
              _this.$emit('submit');
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};